<div class="hover-container" id="hover-container">
  <small>{{ tabTitle | translate }} [{{ tabMode | translate }}]</small>
</div>
